import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('sbc_configuration', '/sbc_configurations')
const actions = generator.generate()

export default actions
